import CONSTANTS from './constants'

import { defaultSortAndFilter } from '@/js/components/Favorites/favorites-constants.js'

// ToDo: Check if these are all used
export default {
  [CONSTANTS.CHECKOUT_CONSTANTS.CHECKOUT]: {
    [CONSTANTS.CHECKOUT_CONSTANTS.SOURCE]: {
      [CONSTANTS.CHECKOUT_CONSTANTS.REDIRECT_URL]: undefined,
      [CONSTANTS.CHECKOUT_CONSTANTS.CHECKOUT_TERMS_URL]: undefined,
      [CONSTANTS.CHECKOUT_CONSTANTS.CHECKOUT_PRIVACY_URL]: undefined,
    },
    [CONSTANTS.CHECKOUT_CONSTANTS.FORM]: {
      [CONSTANTS.CHECKOUT_CONSTANTS.CUSTOMER_ID]: undefined,
      // [CONSTANTS.CHECKOUT_CONSTANTS.DELIVERY_ADDRESS]: undefined,
      [CONSTANTS.CHECKOUT_CONSTANTS.PAYMENT_SERVICE]: undefined,
      [CONSTANTS.CHECKOUT_CONSTANTS.DELIVERY_SERVICE]: undefined,
      // [CONSTANTS.CHECKOUT_CONSTANTS.REFERENCE]: '',
      // [CONSTANTS.CHECKOUT_CONSTANTS.COMMENT]: '',
      [CONSTANTS.CHECKOUT_CONSTANTS.CLIENT_DATA]: {},
      [CONSTANTS.CHECKOUT_CONSTANTS.TOS_AGREED]: false,
    },
  },
  [CONSTANTS.FAVORITES_SORT_AND_FILTER]: defaultSortAndFilter,
  // [CONSTANTS.FAVORITES_FILTER_DATA]: defaultFilterData,
  [CONSTANTS.BASKET_MESSAGES]: [],
}
